import React, {useRef, useState} from 'react';
import clsx from "clsx";
import {IconPhoto} from '@tabler/icons-react';
import { useFileIntake } from "../../../hooks";
import { Button } from "../";
import { useTranslation } from "react-i18next";
import './FileUpload.scss';

export const FileUpload= () => {
  const { t } = useTranslation();

  const intake = useFileIntake();

  const inputRef = useRef<HTMLInputElement>(null);

  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      intake(e.dataTransfer.files, { advance: true });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      intake(e.target.files, { advance: true });
    }
  };

  const onButtonClick = () => {
    inputRef.current?.click();
  };

  return (
    <div className={clsx("dropzone", { active: dragActive })}>
      <div
        className="content"
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={onButtonClick}
        role="button"
        tabIndex={0}
        aria-label={t("fileUpload.dragDrop")}>
        <input
          ref={inputRef}
          type="file"
          className="input"
          multiple={true}
          onChange={handleChange}
          aria-hidden="true"/>

        <div className="icon">
          <IconPhoto />
        </div>

        <div>
          <h2>{t("fileUpload.clickToOpen")}</h2>
          <h3>{t("fileUpload.dropzone")}</h3>
        </div>

        <Button
          onClick={(e) => {
            e.stopPropagation();
            onButtonClick();
          }}
        >
          {t("fileUpload.selectBtn")}
        </Button>
      </div>
    </div>
  );
};
